import React,{useEffect} from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import UserReviews from "./ReviewRating"
import BreadCrumb from "./Cards/BreadCrumbs";
import PublicReviews from "./PublicReviews"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}));

export default function SimpleTabs(props) {
  const {data}= props;
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [searchVal, setsearchVal] = React.useState("");

  useEffect(() => {
  console.log(data)
  setsearchVal(data)
  }, []);


  const handleChange = (event, newValue) => {
    setValue(newValue);

  };

  return (
      <>
         <BreadCrumb
            l1="Dashboard"
            l2=" Manage Reviews"
            dashboardlink="./admindashboard"
          />
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="simple tabs example"
        >
          <Tab className="reportour-1" label="User Reviews" {...a11yProps(0)} />
          <Tab className="reportour-2" label="Public Reviews" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
      <UserReviews/>
      </TabPanel>
      <TabPanel value={value} index={1}>
    <PublicReviews/>
      </TabPanel>
    </div>
    </>
  );
}
